import React from 'react';
import Cross from '../../../../../Assets/Modals/closeIcon.svg';
import Image from '../../../../../Assets/Lens/imagePost.svg';
import Video from '../../../../../Assets/Lens/videoPost.svg';
import { useDispatch } from 'react-redux';
import { closeModal, setModal } from '../../../../../Features/lensSlice';
import PostType from './PostType';

function CreateLens() {
    const dispatch = useDispatch();

    const handleCloseModal = () => {
        dispatch(closeModal());
    }

    const handleSelectPostType = (type) => {
        dispatch(setModal(type));
    }

    return (
        <div className='w-[44%] bg-[#FFFFFF] border border-[#EAEAEA] rounded-[9px] p-4 flex flex-col gap-4'>
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-2xl text-[#121212]'>Create Lens</h1>

                <button onClick={handleCloseModal} className="w-11 h-11 flex items-center justify-center">
                    <img src={Cross} alt="" />
                </button>
            </div>

            <div className="grid grid-cols-2 gap-x-[9px]">
                <PostType 
                    icon={Image} 
                    title={'Default Post'} 
                    onClick={() => handleSelectPostType('default-post')} 
                />

                <PostType 
                    icon={Video} 
                    title={'Video Post'} 
                    onClick={() => handleSelectPostType('video-post')} 
                />
            </div>
        </div>
    );
}

export default CreateLens;
